var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenScreenBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1125 2436",
    style: {
      enableBackground: "new 0 0 1125 2436"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:6.000000e-02;clip-path:url(#XMLID_00000123430009830272816370000007779364500996992156_);fill:url(#SVGID_1_);}\r\n\t\r\n\t\t.st1{opacity:6.000000e-02;clip-path:url(#XMLID_00000123430009830272816370000007779364500996992156_);fill:url(#SVGID_00000022558959446564969870000005948782521656041653_);}\r\n\t\r\n\t\t.st2{opacity:6.000000e-02;clip-path:url(#XMLID_00000123430009830272816370000007779364500996992156_);fill:url(#SVGID_00000081609459948286730720000015514265371501090465_);}\r\n\t\r\n\t\t.st3{opacity:6.000000e-02;clip-path:url(#XMLID_00000123430009830272816370000007779364500996992156_);fill:url(#SVGID_00000090984330400617879230000013520248271770711719_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000093874946908763665020000012702703976138404782_",
    x: 0.6,
    y: 1.5,
    width: 1120.9,
    height: 2431.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000093874946908763665020000012702703976138404782_",
    style: {
      overflow: "visible",
      fill: "#EFEFF0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000145779903695580197990000000420245005022320779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000093874946908763665020000012702703976138404782_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.593,
    y1: 1688.3896,
    x2: 458.7677,
    y2: 1688.3896,
    gradientTransform: "matrix(1.9779 1.9779 -3.3504 3.3504 5549.041 -5852.3398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E72144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#76549E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.06,
      clipPath: "url(#XMLID_00000145779903695580197990000000420245005022320779_)",
      fill: "url(#SVGID_1_)"
    },
    d: " M393.5,711.9l-526.2-526.2c-111.7-111.7-111.7-294.4,0-406.1l0,0c111.7-111.7,294.4-111.7,406.1,0l526.2,526.2 c111.7,111.7,111.7,294.4,0,406.1l0,0C687.9,823.6,505.2,823.6,393.5,711.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030447143500427316860000009895683980691622040_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.0862,
    y1: 1771.9633,
    x2: 784.4469,
    y2: 1771.9633,
    gradientTransform: "matrix(-1.9779 1.9779 -3.3504 -3.3504 7354.6738 5621.1709)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E72144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#76549E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.06,
      clipPath: "url(#XMLID_00000145779903695580197990000000420245005022320779_)",
      fill: "url(#SVGID_00000030447143500427316860000009895683980691622040_)"
    },
    d: " M-133.7,829.8l526.2-526.2c111.7-111.7,294.4-111.7,406.1,0l0,0c111.7,111.7,111.7,294.4,0,406.1l-526.2,526.2 c-111.7,111.7-294.4,111.7-406.1,0l0,0C-245.4,1124.2-245.4,941.5-133.7,829.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181071364197716361920000004850229161107080840_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.4109,
    y1: 1551.0995,
    x2: 871.7716,
    y2: 1551.0995,
    gradientTransform: "matrix(-1.9779 -1.9779 3.3504 -3.3504 -3294.8779 8775.7627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E72144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#76549E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.06,
      clipPath: "url(#XMLID_00000145779903695580197990000000420245005022320779_)",
      fill: "url(#SVGID_00000181071364197716361920000004850229161107080840_)"
    },
    d: " M583.8,1854.6l526.2,526.2c111.7,111.7,111.7,294.4,0,406.1l0,0c-111.7,111.7-294.4,111.7-406.1,0l-526.2-526.2 C66,2149,66,1966.3,177.7,1854.6l0,0C289.4,1742.9,472.1,1742.9,583.8,1854.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096779471547267438900000002238681137474308264_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.5247,
    y1: 1528.1522,
    x2: 551.8854,
    y2: 1528.1522,
    gradientTransform: "matrix(1.9779 -1.9779 3.3504 3.3504 -5100.5107 -2697.748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E72144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#76549E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.06,
      clipPath: "url(#XMLID_00000145779903695580197990000000420245005022320779_)",
      fill: "url(#SVGID_00000096779471547267438900000002238681137474308264_)"
    },
    d: " M1111.1,1736.8L584.9,2263c-111.7,111.7-294.4,111.7-406.1,0l0,0c-111.7-111.7-111.7-294.4,0-406.1L705,1330.7 c111.7-111.7,294.4-111.7,406.1,0l0,0C1222.7,1442.3,1222.7,1625.1,1111.1,1736.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenScreenBg);
export default __webpack_public_path__ + "static/media/OpenScreenBG.3302c49363a6b36942420a4236ec964e.svg";
export { ForwardRef as ReactComponent };